export default __webpack_public_path__ + "static/media/coofinep.5814d9e4.png";